import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("span", { class: "json-tree-indent" }, " ", -1 /* HOISTED */);
const _hoisted_2 = { class: "json-tree-sign" };
const _hoisted_3 = {
    key: 0,
    class: "json-tree-key"
};
const _hoisted_4 = {
    key: 1,
    class: "json-tree-colon"
};
const _hoisted_5 = { class: "json-tree-open" };
const _hoisted_6 = { class: "json-tree-comma" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "json-tree-indent" }, " ", -1 /* HOISTED */);
const _hoisted_8 = { class: "json-tree-deeper" };
const _hoisted_9 = { class: "json-tree-row" };
const _hoisted_10 = { class: "json-tree-close" };
const _hoisted_11 = {
    key: 0,
    class: "json-tree-comma"
};
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", { class: "json-tree-indent" }, " ", -1 /* HOISTED */);
import { onMounted, ref } from "vue";
import JsonTree from "./JSONTree.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JSONTreeRow',
    props: {
        parsed: {},
        level: {},
        foldedProps: {}
    },
    setup(__props) {
        const props = __props;
        const extractStringsBetweenQuotes = (str) => {
            const matches = str === null || str === void 0 ? void 0 : str.match(/"(.*?)"/);
            return matches ? matches[1] : "";
        };
        const expanded = ref(true);
        const hovered = ref(false);
        const format = (n) => {
            if (n > 1)
                return `${n} items`;
            return n ? "1 item" : "no items";
        };
        onMounted(() => {
            expanded.value =
                props.foldedProps.length > 0
                    ? !props.foldedProps.includes(extractStringsBetweenQuotes(props.parsed.key))
                    : props.parsed.depth < props.level;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("span", {
                    class: "json-tree-row json-tree-expando",
                    onClick: _cache[0] || (_cache[0] = ($event) => (expanded.value = !expanded.value)),
                    onMouseover: _cache[1] || (_cache[1] = ($event) => (hovered.value = true)),
                    onMouseout: _cache[2] || (_cache[2] = ($event) => (hovered.value = false))
                }, [
                    _hoisted_1,
                    _createElementVNode("span", _hoisted_2, _toDisplayString(expanded.value ? "-" : "+"), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsed.depth * 2 + 1, (n) => {
                        return (_openBlock(), _createElementBlock("span", {
                            class: "json-tree-indent",
                            key: n
                        }, " "));
                    }), 128 /* KEYED_FRAGMENT */)),
                    (_ctx.parsed.key)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.parsed.key), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    (_ctx.parsed.key)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, ": "))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.parsed.type === "array" ? "[" : "{"), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("span", { class: "json-tree-collapsed" }, " /* " + _toDisplayString(format(_ctx.parsed.value.length)) + " */ ", 513 /* TEXT, NEED_PATCH */), [
                        [_vShow, !expanded.value]
                    ]),
                    _withDirectives(_createElementVNode("span", { class: "json-tree-close" }, _toDisplayString(_ctx.parsed.type === "array" ? "]" : "}"), 513 /* TEXT, NEED_PATCH */), [
                        [_vShow, !expanded.value]
                    ]),
                    _withDirectives(_createElementVNode("span", _hoisted_6, ",", 512 /* NEED_PATCH */), [
                        [_vShow, !expanded.value && !_ctx.parsed.last]
                    ]),
                    _hoisted_7
                ], 32 /* NEED_HYDRATION */),
                _withDirectives(_createElementVNode("span", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsed.value, (item, index) => {
                        return (_openBlock(), _createBlock(JsonTree, {
                            key: index,
                            kv: item,
                            level: _ctx.level,
                            "folded-props": _ctx.foldedProps
                        }, null, 8 /* PROPS */, ["kv", "level", "folded-props"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                    [_vShow, expanded.value]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_9, [
                    _createElementVNode("span", {
                        class: _normalizeClass(["json-tree-ending", { 'json-tree-paired': hovered.value }])
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsed.depth * 2 + 3, (n) => {
                            return (_openBlock(), _createElementBlock("span", {
                                class: "json-tree-indent",
                                key: n
                            }, " "));
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.parsed.type === "array" ? "]" : "}"), 1 /* TEXT */),
                        (!_ctx.parsed.last)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, ","))
                            : _createCommentVNode("v-if", true),
                        _hoisted_12
                    ], 2 /* CLASS */)
                ], 512 /* NEED_PATCH */), [
                    [_vShow, expanded.value]
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
